import { updateUniversalAttributes } from 'features/analytics';

import { IRestaurant } from '@rbi-ctg/store';

export const updateStoreAnalyticsAttributes = (store: IRestaurant) => {
  updateUniversalAttributes({
    selectedStoreId: store?.number ?? '',
    posVendor: store?.pos?.vendor ?? '',
  });
};
